import axios from "./httpClient";
import { ApiType } from "./Types";
import { getUrl } from "./getURL";
import { ErrorMessages } from "../constants";
import { throwApiError } from "./apiError";

/**
 * GET API call using Axios
 * @param cancelToken - Token to cancel multiple requests
 * @returns - Array of zip code List of type number[]
 */

export const locationMasterApi = async (params: {search: string | number, page: number, limit: number}) => {
  try {
    const response = await axios.get(`${getUrl(ApiType.LOCATION_MASTER)}?search=${params.search}&page=${params.page}&limit=${params.limit}`);
    return response.data;
  } catch (error: any) {
    throwApiError(error, ErrorMessages.locationMaster);
  }
};
